const accessTokenKey = "TMF_ACCESS_TOKEN";

export const getAccessToken = () => {
    try {
        const raw = localStorage.getItem(accessTokenKey);
        return raw ? JSON.parse(raw) : {};
    } catch {
        return {};
    }
};

export const setAccessToken = (token: string, id?: string) => {
    const prev = getAccessToken();
    const next = {
        ...prev,
        token: token || prev.token,
    };
    if (id !== undefined) {
        next.id = id;
    }
    localStorage.setItem(accessTokenKey, JSON.stringify(next));
};

export const removeAccessToken = () => {
    localStorage.removeItem(accessTokenKey);
};
